/**
 * HomePage Component
 *
 * Main landing page combining all home page sections.
 */

import React from 'react';
import { PublicLayout } from '../../components/layout';
import { useHreflang } from '@/components/common/Seo';
import {
  HeroSection,
  FeaturedLocations,
  FeaturedListings,
  PropertyTypes,
  ValueProposition,
  BecomeHostCTA,
} from './components';

export const HomePage: React.FC = () => {
  // Pair the English home with the Arabic landing so Google serves each its
  // own language version instead of treating them as duplicates.
  useHreflang('/', '/ar', 'en');
  return (
    <PublicLayout transparentHeader>
      {/* Hero with Search */}
      <HeroSection />

      {/* Featured Locations */}
      <FeaturedLocations />

      {/* Featured Listings */}
      <FeaturedListings />

      {/* Property Types */}
      <PropertyTypes />

      {/* Value Proposition */}
      <ValueProposition />

      {/* Become a Host CTA */}
      <BecomeHostCTA />
    </PublicLayout>
  );
};

export default HomePage;
